const CCTransactionsData = {
  data: {
    'transactionId': 'TRb4382765-1054-4e65-a256-0e7ae4cd1939',
    'ccTransactions': [{
      'dtStamp': '2018-12-18T15:33:40.284+00:00',
      'description': 'Credit Card Verification',
      'cC_Last_4': '8573',
      'cardType': 'mastercard',
      'refId': '85l74XPgvz0MlrfeKQkrZHbCZSR',
      'name': 'CreditCardVerification',
      'amount': {
        'amount': 0.01,
        'currencyType': {
          'name': 'US Dollar',
          'country': 'United States',
          'code': 'USD'
        }
      },
      'accountId': 'RA608a55cf08d848b9ae4cac7402f1c019'
    }]
  }
};

export default class MockBillingService {
  constructor(

  ) {
  }

  getCCTransactions() { 
    return new Promise((resolve) => {
      resolve(CCTransactionsData);
    });
  }
}